import { QRCodeSVG } from 'qrcode.react';
import { Button } from '../../../../common';
import React, { Fragment, useRef } from 'react'
import { downloadQRCode } from '../../utils/qrGenerator';
import ResourceSection from '../../ResourceSection';

interface QrDownloaderProps {
  name: string;
  qrCodeUrl: string;
}

const QrDownloader: React.FC<QrDownloaderProps> = ({ name, qrCodeUrl }) => {
  const qrCodeRef = useRef<HTMLDivElement>(null);

  const handleDownloadQRCode = async () => {
    if (!qrCodeRef.current) return;

    try {
      const svg = qrCodeRef.current.querySelector('svg');
      if (!svg) return;

      await downloadQRCode(svg, `${name}-QR-kod.png`);
    } catch (error) {
      console.error('Error generating QR code:', error);
    }
  };

  return (
    <Fragment>
      <div ref={qrCodeRef} style={{ display: 'none' }}>
        <QRCodeSVG
          value={qrCodeUrl}
          size={400}
          bgColor="#ffffff"
          fgColor="#000000"
          level="H"
          includeMargin={false}
        />
      </div>
      <ResourceSection title='QR-kod till webbshoppen'>
        <p>Här finns er QR-kod att ladda ner, perfekt om du vill skapa egna affischer eller flyers som leder direkt till er shop.</p>
        <Button onClick={handleDownloadQRCode} className='primary alt md'>
          <div className="flex gap-1 items-center justify-center">
            <span>Ladda ned QR-kod</span>
          </div>
        </Button>
      </ResourceSection>
    </Fragment>
  )
}

export default QrDownloader
